const transatelMobileProduct = {
  name: {
    label: "Nom"
  },
  transatelRatePlan: {
    label: "Offre principale"
  },
  transatelDataThreshold: {
    label: "Palier de données"
  },
  transatelOptions: {
    label: "Options",
    label_Display: "Options précédentes",
    allowMoreField: {
      addLabel: "Ajouter",
      removeLabel: "Enlever",
      removingLabel: "Supprimer"
    },
    custom: {
      bill_purchase: "Achat sur facture",
      international: "International",
      data_activation: "Data au compteur",
      mobile_conf: "Conférence mobile"
    }
  },
};

export default transatelMobileProduct;
